import React from "react";
import { auth } from "../firebase";
// import { Button } from "@material-ui/core";

function SignOut() {
  return (
    <div>
      <button className="btn btn-danger" onClick={() => auth.signOut()}>
        Sign Out
      </button>
    </div>
  );
}

export default SignOut;
